export default __webpack_public_path__ + "static/media/uniswap-uni-logo.b26fd45e.png";